<template>
    <vx-popover hover arrow placement="top">
        <vx-badge size="xs" color="rose" data-test="outside-domains-badge">
            <font-awesome-icon :icon="faTriangleExclamation" class="-mx-0.5" /> Outside verified domains
        </vx-badge>
        <template v-slot:content>
            <div class="max-w-xs">
                This team requires SSO and {{ emailDomain(props.email) }} is not a verified domain, so this address
                cannot log in with SSO.
            </div>
        </template>
    </vx-popover>
</template>

<script lang="ts" setup>
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxPopover } from '@voxie/frontend-components';
import { emailDomain } from '~/utils/emailDomain';

const props = defineProps<{
    email: string;
}>();
</script>
